// extracted by mini-css-extract-plugin
module.exports = {"page":"Templates_page__16x5J","page_title":"Templates_page_title__2rfdW","page_item":"Templates_page_item__1A__c"};